import React, { Component } from 'react';
import {BarLoader} from 'react-spinners';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faTimesCircle} from "@fortawesome/free-regular-svg-icons";
import './Thumbnail.scss';

class Thumbnail extends Component {

  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  handleThumbnailClick() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.props.onClick();
  }

  render() {
    const {image, valid, selected, imagesUrl} = this.props;
    const {loading} = this.state;

    const icon = loading ? <BarLoader/> : typeof valid === 'boolean' ? <FontAwesomeIcon icon={valid ? faCheckCircle : faTimesCircle}/> : null;
    let className = 'Thumbnail ';
    className += typeof valid === 'boolean' ? (valid ? 'valid ' : 'invalid ') : '';
    className += selected ? 'selected ' : '';
    className += loading ? 'loading ' : '';

    return (
      <article className={className} onClick={() => this.handleThumbnailClick()}>
        {loading ? <img src={require('../../../assets/images/thumbnail-placeholder.png')} className='placeholder' alt=''/> : null}
        <img src={`${imagesUrl}/${image}.jpg`} onLoad={() => this.setState({ loading: false })} className='thumbnail-image' alt=""/>
        <div className='IconContainer'>
          {icon}
        </div>
      </article>
    );
  }

}

export default Thumbnail;
